/* eslint-disable jsx-a11y/anchor-has-content */
import React from "react";
import { BsLinkedin, BsGithub, BsFacebook } from "react-icons/bs";
const HeaderSocials = () => {
  return (
    <div className="Header_socials">
      <a href="https://www.linkedin.com/in/jaloliddin-yusupov-a311481b6/">
        <BsLinkedin />
      </a>
      <a href="https://github.com/YusupovJaloliddin">
        <BsGithub />
      </a>
      <a href="https://www.facebook.com/jaloliddin.yusupov.9085/">
        <BsFacebook />
      </a>
    </div>
  );
};

export default HeaderSocials;
